import { useEffect } from 'react';
import { projectService } from '../services/projectService';

/**
 * Refreshes ticket counts for all given projects in a SINGLE batch request
 * and updates them in place. Shared by ProjectsView and PlanOverview.
 * Fires whenever the number of projects changes.
 */
export function useRefreshTicketCounts(projects, setProjects) {
  useEffect(() => {
    if (projects.length === 0) return;

    const projectIds = projects.map((p) => p.id);

    projectService
      .refreshTicketCounts(projectIds)
      .then((response) => {
        const counts = response?.counts || {};
        setProjects((prev) =>
          prev.map((p) =>
            counts[p.id] !== undefined
              ? { ...p, ticketCount: counts[p.id] }
              : p
          )
        );
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projects.length, setProjects]);
}
